module.exports = __webpack_public_path__ + "static/media/ordkjedetekstIntrosound.ec795643.mp3";